var user = null;

export const UserSessionService = {
    set: value => user = value,
    clear: () => user = null,
    get: () => user
};